<template>
  <main
    :class="$style['main']"
  >
    <slot />
  </main>
</template>

<script lang="ts" setup>
</script>

<style lang="postcss" module>
.main {
  flex: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 60px);
  min-height: calc(100dvh - 60px);
}
</style>
